import { getPresenceCloudConfig } from '../config/cloudConfig';

export function buildMriFromAADObjectId(aadObjectId?: string): string | undefined {
    // MRI format doc: https://skype.visualstudio.com/SKYPECENTRAL/_wiki/wikis/SKYPECENTRAL.wiki/3055/Cloud-Specific-MRIs
    // The segment is cloud-specific: 'orgid' (WW), 'gcch' (GCCH), 'dod' (DOD)
    // Note: convertFromLegacyMRI (in presence/trouter/utils.ts) preserves the segment when normalizing legacy MRI formats
    const segment = getPresenceCloudConfig().mriOrgSegment;
    return aadObjectId ? `8:${segment}:${aadObjectId}` : undefined;
}
